<template>
  <div>
    <div class="content-title content-mb-14 uf_name">
      <span><slot></slot> ОКПО</span>
      <VDropdown
        trigger="click"
        placement="bottom-start"
        popperClass="custom-popper"
        :overflow-padding="16"
      >
        <a class="info-holder-icon" />
        <template #popper>
          <span
            class="custom-popper-content"
            v-html="$parent.project.UF_HELP.FIELDS.STEP2['UF_OKPO']"
          />
        </template>
      </VDropdown>
    </div>
    <div class="row myrow content-mb-42">
      <div
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'ORG_INFO',
            'LOGIC',
            'UF_OKPO'
          )
        }"
      >
        <input
          type="text"
          :disabled="$parent.$parent.projectDisabled"
          v-model="okpo"
          class="i-main-style i-wid-13"
          maxlength="10"
        />
        <div class="error-text">
          {{ $parent.$parent.checkErrorText("ORG_INFO", "LOGIC", "UF_OKPO") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dropdown as VDropdown } from "floating-vue";

export default {
  name: "uf_okpo",
  components: {
    VDropdown
  },
  computed: {
    okpo: {
      get() {
        return this.$parent.project.ORG_INFO.UF_OKPO;
      },
      set(value) {
        const cleaned = (value || "").replace(/\D/g, "");
        this.$parent.project.ORG_INFO.UF_OKPO = cleaned;
        if (cleaned !== "") {
          this.$parent.$parent.removeError("ORG_INFO", "LOGIC", "UF_OKPO");
        }
      }
    }
  }
};
</script>

<style scoped></style>
